window._ = require('lodash');
import Vue from 'vue'
window.Vue = Vue;
window.axios = require('axios');
